<template>
    <up-low-paging @pageChange="pageChange" :pagingInfo="pagingInfo" v-if="listingType !== null" :ignore-watch-route="true">
        <Loading :show="isLoading"></Loading>
        <div>
            <div v-if="filter !== null">
                <div v-if="filter.keyword !== null">
                    <span class="btn" style="color:gray;"> {{ lang.common.keyword }}:</span><span class="btn">
                        {{ filter.keyword }} </span>
                </div>
                <div>
                    <div role="group" class="btn-group">
                        <span v-for="fCat in filterCats" class="btn"><span class="glyphicon glyphicon-check"></span>
                            <span v-if="filterInfo.catsList && filterInfo.catsList[fCat.parentId]">{{ filterInfo.catsList[fCat.parentId]}} :</span> {{ fCat.name }}
                        </span>
                    </div>
                    <div role="group" class="btn-group">
                        <span  v-for="fTag in filterTags" class="btn"><span class="glyphicon glyphicon-check"></span>
                        <span v-if="filterInfo.catsList && filterInfo.catsList[fTag.parentId]">{{ filterInfo.catsList[fTag.parentId]}} :</span> {{ fTag.name }} 
                        </span>
                    </div>
                    <div role="group" class="btn-group"
                        v-if="filterCats.length > 0 || filterTags.length > 0 || filter.keyword !== null">
                        <router-link :to="{ name: listingType }">
                            <button type="button" class="btn btn-default">{{ lang.common.removeFilter }}</button>
                            <button type="button" class="btn btn-default">
                                <span class="glyphicon glyphicon-remove"></span>
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="items !== null && items.length === 0">
                <div class="alert alert-warning" role="alert" style="text-align:center;">
                    <span>{{ lang.common.noData }}</span>
                </div>
            </div>

            <div v-for="item in items">
                <!-- <item-card :item="item" :listing-type="listingType"></item-card> -->
                <component :is="listingCard" :item="item" :listing-type="listingType"></component>
            </div>
        </div>
    </up-low-paging>
</template>
<script>
import UpLowPaging from './base/UpLowPaging.vue';
import Loading from './base/LoadingRelative.vue';
import PagedInfos from './PagedInfos.vue';

import InfoCard from './listing/InfoCard.vue';
import ImageCard from './listing/ImageCard.vue';
import MediaCard from './listing/MediaCard.vue';
import TextCard from './listing/TextCard.vue';

export default {
    props: {
        "filterInfo": { type: Object, default: null },
        "listingType": { type: String, default: null }
    },
    components: {
        InfoCard,
        ImageCard,
        MediaCard,
        TextCard,
        UpLowPaging: UpLowPaging,
        Loading: Loading,
        PagedInfos: PagedInfos
    },
    computed: {
        listingCard: function () {
            var card = this.$store.getters.configs.layout.listingCard;
            if(!card) card = "InfoCard";
            return card;
        },
        lang: function () {
            return this.$store.getters.lang;
        },
        apiClient: function () {
            if (this.listingType === "listing") {
                return this.mxnAgxApi.listingApiClient;
            }
            return this.mxnAgxApi.articlesApiClient;
        },
        filterCats: function () {
            if (!this.filterInfo) return [];
            if (this.filterInfo === null || this.filter == null) return [];
            if (this.listingType === "listing") {
                return this.getMatchedCatPair2(this.filterInfo.listingCatNode, this.filter.cats);
            }
            if (this.listingType === "articles") {
                return this.getMatchedCatPair2(this.filterInfo.articles, this.filter.cats);
            }
        },
        filterTags: function () {
            if (!this.filterInfo) return [];
            if (this.filterInfo === null || this.filter == null) return [];
            return this.getMatchedCatPair2(this.filterInfo.itemTagCatNode, this.filter.tags);
        },
        pagedInfoMain: function () {
            var arr = this.$store.getters.configs.pagedInfos.listing;
            if (arr.length > 0) return arr[0];
            return null;
        }
    },
    filters: {

    },
    methods: {
        getMatchedCatPair2: function (rootCatNode, idsArr) {
            var retPairs = [];
            if (rootCatNode === null) return retPairs;
            var checkCat = (catNode, catId) => {
                if (catNode.catId === catId) {
                    retPairs.push(catNode);
                } else {
                    if (catNode.childs.length > 0) {
                        catNode.childs.forEach((node) => checkCat(node, catId));
                    }
                }
            }
            if (idsArr && idsArr.length > 0) {
                idsArr.forEach((catId) => {
                    checkCat(rootCatNode, catId);
                });
            }
            return retPairs;
        },
        getRoutePage: function () {
            var rPage = this.$route.query.page;
            if (typeof rPage === "undefined") {
                rPage = 1;
            };
            return rPage;
        },
        pageChange: function (page) {
            var route = this.$router.currentRoute;
            var query = route.query;
            var newQuery = {};
            for (var n in query) {
                newQuery[n] = query[n];
            };
            newQuery.page = page;
            var newRoute = {
                name: this.listingType,
                query: newQuery
            };
            this.$router.push(newRoute);
        },
        textChange: function (page, totalPage) {
            this.page = page;
            this.totalPage = totalPage;
        },
        loadItems: function (queryString) {
            this.isLoading = true;
            this.apiClient.getItemsPrms(queryString).done((data) => {
                this.isLoading = false;
                var filter = data.filter;
                this.filter = filter;
                this.pagingInfo = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                this.items = data.posts;
                this.loadedQuery = queryString;
                this.onItemsLoaded(data);
            });
        },
        getQueryString: function () {
            var queryString = this.$route.fullPath;
            queryString = queryString.split('?')[1];
            if (queryString == null) {
                queryString = "";
            }
            return queryString;
        },
        initPaging: function () {
            this.loadItems(this.getQueryString());
        },
        onItemsLoaded(ret){
            console.log("items loaded");
            this.$emit("itemsLoaded",ret);
        }
    },
    data: function () {
        return {
            items: null,
            page: 1,
            totalPage: 1,
            pagingInfo: { page: 1, pageSize: 1, count: 1 },
            filter: null,
            isLoading: false,
            loadedQuery: null,
            timeStamp: new Date().toLocaleString()
        }
    },
    watch: {
        '$route'(to, from) {
            console.log("route change fired:" + this.timeStamp);

            if (to.name === this.listingType) {
                this.page = this.getRoutePage();
                var qstr = this.getQueryString();
                console.log('loadedQuery:', this.loadedQuery, ',current query:', qstr, ',', this.loadedQuery === qstr);
                if (qstr === this.loadedQuery) {
                    return;
                }
                this.loadItems(qstr);
            }
        }
    },
    mounted: function () {
        this.initPaging();
    },
    activated: function () {
        console.log('activated');
    },
    deactivated: function () {
        console.log('deactivated');
    }
}
</script>